(function () {
  'use strict';

  function init() {
    var wrapper = document.querySelector('[data-infinite-scroll="true"]');
    if (!wrapper) return;

    var grid = wrapper.querySelector('[data-collection-grid]');
    var controls = wrapper.querySelector('[data-infinite-scroll-controls]');
    if (!grid || !controls) return;

    var sentinel = controls.querySelector('[data-infinite-scroll-sentinel]');
    var status = controls.querySelector('[data-infinite-scroll-status]');

    var state = {
      nextUrl: controls.getAttribute('data-next-url') || '',
      loading: false,
      done: false
    };

    if (!state.nextUrl) {
      state.done = true;
      return;
    }

    function setLoading(isLoading) {
      state.loading = isLoading;
      if (status) {
        if (isLoading) {
          status.removeAttribute('hidden');
        } else {
          status.setAttribute('hidden', '');
        }
      }
    }

    function loadNext() {
      if (state.loading || state.done || !state.nextUrl) return;
      setLoading(true);

      fetch(state.nextUrl, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var nextGrid = doc.querySelector('[data-collection-grid]');
          if (nextGrid) {
            var fragment = document.createDocumentFragment();
            Array.prototype.slice.call(nextGrid.children).forEach(function (child) {
              if (child.classList && child.classList.contains('collection-empty')) return;
              fragment.appendChild(child);
            });
            grid.appendChild(fragment);
          }

          var nextControls = doc.querySelector('[data-infinite-scroll-controls]');
          var newUrl = nextControls ? nextControls.getAttribute('data-next-url') : '';
          if (newUrl) {
            state.nextUrl = newUrl;
            controls.setAttribute('data-next-url', newUrl);
          } else {
            state.nextUrl = '';
            state.done = true;
            if (observer && sentinel) observer.unobserve(sentinel);
          }

          document.dispatchEvent(new CustomEvent('collection:products-appended', {
            detail: { wrapper: wrapper, grid: grid }
          }));
        })
        .catch(function (error) {
          console.error('[infinite-scroll] failed to load next page', error);
          state.done = true;
          if (observer && sentinel) observer.unobserve(sentinel);
        })
        .then(function () {
          setLoading(false);
        });
    }

    var observer = null;

    if ('IntersectionObserver' in window && sentinel) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, { rootMargin: '400px 0px' });

      observer.observe(sentinel);
    } else {
      var onScroll = function () {
        if (state.loading || state.done) return;
        var rect = controls.getBoundingClientRect();
        if (rect.top - window.innerHeight < 400) loadNext();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
